<div class="db-image-optimizer-pages">
  <div>
    <div class="db-image-optimizer-pages-list">
      <div class="db-image-optimizer-pages-list-wrap" [ngClass]="{'disabled-with-overlay': demoUser}">
        <div class="db-image-optimizer-pages-form"
             [ngClass]="{'paid-client': (currentSubscription?.paidClient || !!website?.domain_hash)}">

          <div class="db-image-optimizer-pages-header mb20">
            <h2 class="mb4">Per page image optimization</h2>
            <p *ngIf="currentSubscription?.trialBoosterClient">Optimize a 50K images per month for 6 pages of your website.</p>
            <p *ngIf="!currentSubscription?.trialBoosterClient">Optimize an unlimited images for all pages of your website.</p>
          </div>

          <div>
            <div class="ds-input-wrap">
              <input [formControl]="pageUrl" type="text"
                     class="ds-input" [ngClass]="{'error': (pageUrl?.invalid && pageUrl?.value !== ''),
                     'disabled':
                      stats?.usedCountFromLimit >= stats?.planLimit }"
                     [placeholder]="website?.site_url">
              <span *ngIf="(pageUrl?.touched && pageUrl?.invalid && pageUrl?.value !== '') || serverError"
                    class="ds-input-error-msg"
                    [innerHTML]="pageUrl?.errors['required'] ? 'This field is required.' : null"></span>
            </div>
            <a class="ds-btn-green"
               [ngClass]="{'ds-btn-disabled': pageUrl.invalid || pageUrl.value === '' ||
               loading || (currentSubscription?.trialBoosterClient && stats?.usedCountFromLimit >= stats?.planLimit)}"
               (click)="validatePageUrl(!(currentSubscription?.paidClient || !!website?.domain_hash) && optimizedPages?.length === 6)">
              <span *ngIf="!loading"
                    [innerHTML]="'text_customRulesBtn' | dbText | lowerCaseSpecificWords"></span>
              <span class="ds-spinner-circle" *ngIf="loading"></span>
            </a>
          </div>

          <div class="ds-notification-warning ds-notification-error mb25"
               *ngIf="(serverError === 'Optimization failed' || reoptimizationError) && !noImagesError">
            <div>
              <i class="db-icon db-icon-ds-info-bg"></i>
              <p>
                <b>Something Went Wrong. </b> An Error occurred while optimizing images, please <a class="text-underline" (click)="onClick.emit()">contact us.</a>
              </p>
            </div>
          </div>

          <div class="ds-notification-warning mb25"
               *ngIf="noImagesError">
            <div>
              <i class="db-icon db-icon-ds-info-bg"></i>
              <p>
                No images were detected on this page to optimize
              </p>
            </div>
          </div>

        </div>

        <hr class="separator" *ngIf="!!optimizedPages?.length">
        <div class="db-optimized-pages mt20" *ngIf="!!optimizedPages?.length">
          <div>
            <div class="db-optimized-pages-header">
              <p>URL</p>
              <p>Last optimization</p>
              <p>Image count</p>
              <p>Image size</p>
              <p>Reoptimize</p>
            </div>
            <div class="db-optimized-pages-list" [ngClass]="{'db-withScroll': optimizedPages?.length > 6}">
              <div class="db-optimized-pages-list-item"
                   *ngFor="let page of optimizedPages; let index = index">
                <a target="_blank" rel="noopener"
                   [dsTooltip]="'<p style=\'font-weight: 600; color: #323A4580;\'>URL</p><b class\'.ds-tooltip-title\'>' + page?.url + '</b>'"
                   dsTooltipPosition="bottom"
                   [href]="page?.url" [innerHTML]="page?.url === website?.site_url ? page?.url : (page?.url | trimHomeUrl:  website?.site_url)"></a>
                <p [innerHTML]="page?.date ? (page?.date | date) : 'Just now'"></p>
                <p [innerHTML]="page?.imagesCount + ' (' + page?.imagesMode + ')'"></p>
                <p [innerHTML]="page?.imagesSize | size: {unit: 'B'}"></p>
                <div class="db-reoptimize" [ngClass]="{'disabled': !!reoptimizing}" (click)="onReOptimizeClick((page?.url)?.toString(), index); choosedPage = index">
                  <i *ngIf="index !== choosedPage || !reoptimizing" class="db-icon db-icon-reoptimize-icon"></i>
                <span class="ds-spinner-circle"  *ngIf="index === choosedPage && !!reoptimizing"></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

